import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Texture, Spritesheet } from "pixi.js";
export class RaidResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("RaidResourcePackage");
    }
    public get assets_views_raid_atlases_shield_shield_crack_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/shield_crack.png");
    }
    public get assets_views_raid_atlases_shield_shield_piece_1_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/shield_piece_1.png");
    }
    public get assets_views_raid_atlases_shield_shield_piece_2_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/shield_piece_2.png");
    }
    public get assets_views_raid_atlases_shield_shield_piece_3_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/shield_piece_3.png");
    }
    public get assets_views_raid_atlases_shield_shield_piece_4_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/shield_piece_4.png");
    }
    public get assets_views_raid_atlases_shield_shield_piece_5_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/shield_piece_5.png");
    }
    public get assets_views_raid_atlases_shield_whole_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/shield/whole.png");
    }
    public get assets_views_raid_atlases_target_light_json(): Object {
        return this.resource<Object>("assets/views/raid/atlases/target_light.json");
    }
    public get assets_views_raid_atlases_target_light_png(): Texture {
        return this.resource<Texture>("assets/views/raid/atlases/target_light.png");
    }
    public get assets_views_raid_ui_ui_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/raid/ui/ui-0_1x.atlas.json");
    }
    public get assets_views_raid_ui_raid_samary_bg_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["raid_samary_bg.png"];
    }
    public get assets_views_raid_ui_glow_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["glow.png"];
    }
    public get assets_views_raid_ui_shield_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["shield.png"];
    }
    public get assets_views_raid_ui_tittle_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["tittle.png"];
    }
    public get assets_views_raid_ui_Building_0005_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["Building_0005.png"];
    }
    public get assets_views_raid_ui_target_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["target.png"];
    }
    public get assets_views_raid_ui_you_won_text_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["you_won_text.png"];
    }
    public get assets_views_raid_ui_one_target_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["one_target.png"];
    }
    public get assets_views_raid_ui_coin_icon_png(): Texture {
        return this.assets_views_raid_ui_ui_0_1x_atlas_json.textures["coin_icon.png"];
    }
    public get assets_views_raid_ui_ui_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/raid/ui/ui-0_1x.atlas.png");
    }
    public get assets_views_raid_ui_ui_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/raid/ui/ui-1_1x.atlas.json");
    }
    public get assets_views_raid_ui_fiery_exploding_burst_png(): Texture {
        return this.assets_views_raid_ui_ui_1_1x_atlas_json.textures["fiery_exploding_burst.png"];
    }
    public get assets_views_raid_ui_raid_back_png(): Texture {
        return this.assets_views_raid_ui_ui_1_1x_atlas_json.textures["raid_back.png"];
    }
    public get assets_views_raid_ui_raid_front_png(): Texture {
        return this.assets_views_raid_ui_ui_1_1x_atlas_json.textures["raid_front.png"];
    }
    public get assets_views_raid_ui_ui_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/raid/ui/ui-1_1x.atlas.png");
    }
}

